(function(){
  if (window.__uuGlitch) return; window.__uuGlitch = true;
  var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');
  var SEL = '.uu-btn, .uu-vh__btn, .uu-hero .uu-h1, .uu-vh__h';
  function fire(el){
    if (!el || el.disabled || (rm && rm.matches)) return;
    var now = Date.now(); if (now - (el._gl || 0) < 900) return; el._gl = now;
    el.setAttribute('data-gl', el.textContent.replace(/\s+/g,' ').trim());
    el.classList.add('uu-gl-on'); el.classList.remove('is-gl'); void el.offsetWidth; el.classList.add('is-gl');
    clearTimeout(el._glt); el._glt = setTimeout(function(){ el.classList.remove('is-gl'); }, 800);
  }
  window.uuGlitch = fire;
  function pick(e){ var b = e.target.closest && e.target.closest(SEL); if (b) fire(b); }
  document.addEventListener('pointerover', function(e){ if (e.pointerType === 'mouse') pick(e); });
  document.addEventListener('pointerdown', function(e){ if (e.pointerType !== 'mouse') pick(e); });
  document.addEventListener('focusin', function(e){ if (e.target.matches && e.target.matches('.uu-btn:focus-visible, .uu-vh__btn:focus-visible')) fire(e.target); });
  /* Hero headline: glitch once on load, and once more each time it scrolls back into view. No repeating timer. */
  function heroes(){
    var hs = document.querySelectorAll('.uu-hero .uu-h1, .uu-vh__h');
    hs.forEach(function(h, i){ setTimeout(function(){ fire(h); }, 500 + i * 200); });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(es){ es.forEach(function(en){ if (en.isIntersecting) fire(en.target); }); }, { threshold: .6 });
    hs.forEach(function(h){ io.observe(h); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', heroes); else heroes();
})();